import { useModal } from "@/Contexts";
import ModalContainer from "@/components/modalContainer";
import { Translate, useTrans } from "@/translations";

export const NoTerminalsModal: React.FC = () => {
  const { t } = useTrans();
  const { hideModal } = useModal();

  return (
    <ModalContainer
      title={"errors:noTerminals"}
      onConfirm={hideModal}
      onCancel={hideModal}
      onConfirmText="common:OK"
      disableCancelButton
    >
      <div className="pt-3 whitespace-pre">
        <Translate
          i18nKey={"hints:noTerminalsForAccessParents"}
          values={{
            link: t("sidebarLabels:manageInfrastructure"),
          }}
          components={[
            <a
              href="/infrastructure/manage"
              style={{ textDecoration: "underline" }}
              target="_blank"
              rel="noreferrer"
            >
              ${t("sidebarLabels:manageInfrastructure")}
            </a>,
          ]}
        />
      </div>
    </ModalContainer>
  );
};
